import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const InputOldPinLazy = lazyLoader(
  () => import('./InputOldPin' /* webpackChunkName: "input-old-pin" */),
);

const InputOldPin = () => {
  return (
    <Suspense fallback={null}>
      <InputOldPinLazy />
    </Suspense>
  );
};

export default InputOldPin;
